<div class="ds-icon" [style.background-image]="'url(/assets/ds-icons/' + name + '.svg)'"></div>